/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Carriers API
 * Carrier-facing API for the carrier portal (carriers.freightsimple.com).  Authentication: a carrier opens a permanent signed login link, exchanges it for a session token, and presents that token as a bearer on every other call. `CarrierPortalAuthenticationFilter` validates the session and scopes each request to one carrier. Operations use `security: []` (no Micronaut JWT) — the filter is the authenticator, the same model the agents API uses.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface PerformanceServiceQualitySplit
 */
export interface PerformanceServiceQualitySplit {
  /**
   *
   * @type {string}
   * @memberof PerformanceServiceQualitySplit
   */
  label: string;
  /**
   *
   * @type {number}
   * @memberof PerformanceServiceQualitySplit
   */
  shipments: number;
  /**
   *
   * @type {number}
   * @memberof PerformanceServiceQualitySplit
   */
  beyondWindowRate?: number;
  /**
   *
   * @type {number}
   * @memberof PerformanceServiceQualitySplit
   */
  averageDaysBeyondEarliest?: number;
}

/**
 * Check if a given object implements the PerformanceServiceQualitySplit interface.
 */
export function instanceOfPerformanceServiceQualitySplit(
  value: object,
): value is PerformanceServiceQualitySplit {
  if (!("label" in value) || value["label"] === undefined) return false;
  if (!("shipments" in value) || value["shipments"] === undefined) return false;
  return true;
}

export function PerformanceServiceQualitySplitFromJSON(
  json: any,
): PerformanceServiceQualitySplit {
  return PerformanceServiceQualitySplitFromJSONTyped(json, false);
}

export function PerformanceServiceQualitySplitFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PerformanceServiceQualitySplit {
  if (json == null) {
    return json;
  }
  return {
    label: json["label"],
    shipments: json["shipments"],
    beyondWindowRate:
      json["beyondWindowRate"] == null ? undefined : json["beyondWindowRate"],
    averageDaysBeyondEarliest:
      json["averageDaysBeyondEarliest"] == null
        ? undefined
        : json["averageDaysBeyondEarliest"],
  };
}

export function PerformanceServiceQualitySplitToJSON(
  json: any,
): PerformanceServiceQualitySplit {
  return PerformanceServiceQualitySplitToJSONTyped(json, false);
}

export function PerformanceServiceQualitySplitToJSONTyped(
  value?: PerformanceServiceQualitySplit | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    label: value["label"],
    shipments: value["shipments"],
    beyondWindowRate: value["beyondWindowRate"],
    averageDaysBeyondEarliest: value["averageDaysBeyondEarliest"],
  };
}
